import { render, staticRenderFns } from "./SoftwareContent.vue?vue&type=template&id=3e6ee79e"
import script from "./SoftwareContent.vue?vue&type=script&lang=js"
export * from "./SoftwareContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports